<template>
  <teleport to="#teleport">
    
      <div class="popup-profile">
        <transition name="transition-fade" appear>
          <div class="popup-content" @click="closePopup">


            <template v-if="currentMenuLevel === 'main'">

              <template v-if="useAuth().isAuth()">
                

                
                <NuxtLink :to="useAuth().getLink() || '/'" class="profile-link">
                  <div class="avatar-container">
                    <img loading="lazy" class="avatar" :src="useAuth().getAvatarLittle()">
                    <GeneralLabelUser position="absolute" :isOfficial="useAuth().isOfficial()" :isPremium="useAuth().isPremium()" size="small"/>
                  </div>
                  <div class="nm">
                    <div class="profile-username">
                      @{{ useAuth().getName() }}                      
                    </div>
                    <div class="view-profile">View My Profile</div>
                  </div>
                </NuxtLink>
                
                <NuxtLink :to="'/diaries/edit/new'" class="profile-link">
                  <i class="icon-plus"></i>
                  <div class="nm">{{ $t('main_menu_start_diary') }}</div>
                </NuxtLink>

                <NuxtLink 
                  v-if="useAuth().isAuth() && useAuth().getAccess('view_extra')" 
                  :to="(useAuth().getLink() || '') + '/shorts?eed=true'"
                  class="profile-link" 
                  >
                  <i class="icon-shorts"></i> 
                  <div class="nm">Create Short</div>
                </NuxtLink>
                
              </template>

              <template v-if="!useAuth().isAuth()" >

                <NuxtLink  class="profile-link" to="/auth/signin">        
                  <i class="icon-lock ic"></i> 
                  <div class="nm">{{ $t('main_menu_login') }}</div>      
                </NuxtLink>      
              
                <NuxtLink class="profile-link" to="/auth/signup">                
                  <i class="icon-user-new ic"></i> 
                  <div class="nm">{{ $t('main_menu_signup') }}</div>
                </NuxtLink>
                
              </template>


              <!-- Переключатель языка с навигацией -->
              <div class="profile-link menu-item" @click.stop="toggleLocale">
                <i v-if="locale === locale" class="icon-translate current-language"></i>
                <div class="nm">{{ getLocaleName(locale) }}</div>
                <i class="icon-angle-right submenu-arrow"/>
              </div>

              <!-- Переключатель темы с навигацией -->
              <div class="profile-link menu-item" @click.stop="toggleTheme">
                <i class="icon-sun"></i>
                <div class="nm">{{ getThemeDisplayName(getCurrentTheme()) }} Theme</div>
                <i class="icon-angle-right submenu-arrow"/>
              </div>

              <template v-if="useAuth().isAuth()">   
                
                <div class="hr"></div>
   
                <NuxtLink :to="(useAuth().getLink() || '') + '/settings'" class="profile-link">
                  <i class="icon-setting"></i>
                  <div class="nm">Settings</div>
                </NuxtLink>      

                <div @click="useAuth().logout({redirect: '/'})" class="profile-link logout-btn">
                  <i class="icon-logout"></i>
                  <div class="nm">Logout</div>
                </div>

              </template>

            </template>

            <!-- Меню выбора языка -->
            <template v-if="currentMenuLevel === 'language'">

              
                <!-- Кнопка "Назад" -->
                <div class="profile-link back-button" @click.stop="goBack">
                  <i class="icon-angle-left"></i>
                  <div class="nm">Select Language</div>
                </div>
              
              <div class="hr"></div>
              
              <!-- Список языков -->
              <template
                v-for="l in locales"
                :key="l.code"
              >
                <div
                  v-if="((l.code !== 'en-tr') || (l.code === 'en-tr' && useAuth().getAccess('view_translation_keys')))"
                  class="profile-link language-option"
                  :class="{ 'active': l.code === locale }"
                  @click.prevent.stop="selectLocale(l.code)"
                >
                  <div class="check-placeholder">
                    <i v-if="l.code === locale" class="icon-check current-language"></i>
                  </div>
                  <div class="nm">{{ l.name }}</div>
                </div>
              </template>
              
            </template>

            <!-- Меню выбора темы -->
            <template v-if="currentMenuLevel === 'theme'">
              
                <!-- Кнопка "Назад" -->
                <div class="profile-link back-button" @click.stop="goBack">
                  <i class="icon-angle-left"></i>
                  <div class="nm">Select Theme</div>
                </div>
              
              <div class="hr"></div>
              
              <!-- Список тем -->
              <div
                class="profile-link theme-option"
                :class="{ 'active': getCurrentTheme() === 'light' }"
                @click.prevent.stop="selectTheme('light')"
              >
                <div class="check-placeholder">
                  <i v-if="getCurrentTheme() === 'light'" class="icon-check current-theme"></i>
                </div>
                <div class="nm">Light</div>
              </div>

              <div
                class="profile-link theme-option"
                :class="{ 'active': getCurrentTheme() === 'dark' }"
                @click.prevent.stop="selectTheme('dark')"
              >
                <div class="check-placeholder">
                  <i v-if="getCurrentTheme() === 'dark'" class="icon-check current-theme"></i>
                </div>
                <div class="nm">Dark</div>
              </div>

              <!-- <div
                class="profile-link theme-option"
                @click.prevent.stop="selectTheme('system')"
              >
                <div class="check-placeholder">
                </div>
                <span class="nm">System</span>
              </div> -->
              
            </template>
          
          </div>
        </transition>
        <div class="popup-overlay" @click="closePopup"></div>
      </div>
    
  </teleport>
</template>

<script setup lang="ts">

import { LocalesImages } from '@/types/other'

const emit = defineEmits(['close'])

// Сброс состояния меню при закрытии
const closePopup = () => {
  currentMenuLevel.value = 'main'
  menuHistory.value = []
  emit('close')
}

// Переключатель языка - логика из Navbar.vue
const { $dayjs } = useNuxtApp()
const { locale, locales, setLocale } = useI18n()
const flagLocale = computed(() => (LocalesImages as any)[locale.value])

// Переключатель темы - логика из Footer.vue
const navbarTheme = useNavbarTheme()
const theme = ref(navbarTheme.value == 'dark' ? 1 : 0)

// Система вложенных меню
const currentMenuLevel = ref<'main' | 'language' | 'theme'>('main')
const menuHistory = ref<string[]>([]) // История для навигации назад

const getLocaleName = function(vl: string) {
  var sel = locales.value.filter(i => i.code == vl);
  return sel[0]?.name;
}

// Навигация по меню
const goToMenu = (menuLevel: 'main' | 'language' | 'theme') => {
  if (currentMenuLevel.value !== 'main') {
    menuHistory.value.push(currentMenuLevel.value)
  }
  currentMenuLevel.value = menuLevel
}

const goBack = () => {
  const previousLevel = menuHistory.value.pop()
  if (previousLevel) {
    currentMenuLevel.value = previousLevel as 'main' | 'language' | 'theme'
  } else {
    currentMenuLevel.value = 'main'
  }
}

const toggleLocale = () => {
  goToMenu('language')
}

const selectLocale = (localeCode: string) => {
  (setLocale as any)(localeCode);
  ($dayjs as any).locale(localeCode);
  closePopup() // Закрываем попап и сбрасываем состояние
}

const toggleTheme = () => {
  goToMenu('theme')
}

const selectTheme = (themeValue: 'light' | 'dark' | 'system') => {
  if (themeValue === 'system') {
    // Автоматическое определение темы по системным настройкам
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    navbarTheme.value = prefersDark ? 'dark' : 'light'
    theme.value = prefersDark ? 1 : 0
  } else {
    navbarTheme.value = themeValue
    theme.value = themeValue === 'dark' ? 1 : 0
  }
  closePopup() // Закрываем попап и сбрасываем состояние
}

// Получить текущую тему для отображения
const getCurrentTheme = () => {
  return navbarTheme.value
}

const getThemeDisplayName = (themeValue: string) => {
  switch(themeValue) {
    case 'light': return 'Light'
    case 'dark': return 'Dark'
    case 'system': return 'System'
    default: return 'Light'
  }
}

</script>

<style scoped>
.popup-profile {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
 

.popup-content {
  background: var(--un-background-color-gray-light);
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  min-width: 260px;
  padding: 0;
  margin-top: 52px;
  margin-right: 20px;
}

.profile-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.profile-links li {
  margin: 0;
}

.profile-username {
  font-weight: bold;
  color: var(--un-text-color);
  margin-bottom: 0.3rem;
  position: relative;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-link {
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0.8rem 1.3rem;
  text-decoration: none;
  color: var(--un-text-color);
  font-weight: 500;
  transition: background-color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  border-radius: 12px;
}

.profile-link:hover {
  background-color: var(--un-background-color-gray);
}

.profile-link .avatar-container {
  position: relative;
}

.profile-link .avatar {
  width: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  object-fit: cover;
}
.profile-link .view-profile {
  color: var(--un-text-color-primary);
}

.link-icon {
  margin-right: 12px;
  font-size: 18px;
}

.logout-btn {
  border-top: 1px solid var(--un-element-color-gray-light);
}

/* Language switcher styles */
.lang i {
  margin-left: auto;
}

.lang.sub {
  padding-left: 0.6rem;
  /* border-left: 2px solid var(--un-element-color-gray-light); */
  margin-left: 0.8rem;
}

/* .icon_lang styles removed - no longer needed */

.hr{
  border-top: 1px solid var(--un-element-color-gray-light);
}

/* Theme switcher styles - commented out for now */
/* .theme-switcher {
  border-top: 1px solid var(--un-element-color-gray-light);
  border-bottom: 1px solid var(--un-element-color-gray-light);
  margin: 0.5rem 0 0rem 0;
} */

/* Navigation styles */
.menu-item {
  position: relative;
}

.submenu-arrow {
  margin-left: auto;
  font-size: 0.8rem;
  color: var(--un-text-color-light);
  transition: transform 0.2s ease;
}

.back-button {
  font-weight: 600;
}

.back-button i {

  font-size: 1.2rem;
}

.language-option.active {
  background-color: var(--un-background-color-gray-medium);
  font-weight: 600;
}

.check-placeholder {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 10px; */
}

.current-language {
  color: var(--un-success);
  font-size: 0.9rem;
}

.theme-option.active {
  background-color: var(--un-background-color-gray-medium);
  font-weight: 600;
}

.current-theme {
  color: var(--un-success);
  font-size: 0.9rem;
}

/* Hover effects */
.menu-item:hover .submenu-arrow {
  transform: translateX(2px);
}

/* animation */

@media (prefers-color-scheme: dark) {
  
}
</style>
